import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import React from 'react';
import { Table, TableBody, TableHead, TableRow, Typography } from '@applyboard/ui-components';
import Questions from "./Questions";
import { TableCellStyled, RawTypography } from "./style";
import { DETAIL_TITLES } from "./consts";
var setTypographyElement = function setTypographyElement(attribute, field) {
  var elementText = null;
  if (typeof field === 'boolean') {
    elementText = field ? 'True' : 'False';
  } else if (Array.isArray(field)) {
    if (attribute === 'additionalAttachments') {
      elementText = field.reduce(function (currentText, attachmentData) {
        if (currentText.length === 0) return attachmentData[0];
        return "".concat(currentText, ", ").concat(attachmentData[0]);
      }, '');
    } else {
      elementText = field.join(', ');
    }
  } else if (attribute === 'requiredState') {
    elementText = DETAIL_TITLES[field]; // special display text required
  } else if (field !== null) {
    elementText = field;
  }
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, elementText);
};
var setElement = function setElement(attribute, field) {
  // requires special element to display content
  if (attribute === 'internalDescription' || attribute === 'description') {
    return /*#__PURE__*/React.createElement(RawTypography, {
      variant: "paragraph",
      dangerouslySetInnerHTML: {
        __html: field
      }
    });
  }
  if (attribute === 'questions') {
    return /*#__PURE__*/React.createElement(Questions, {
      questionsDifferences: field
    });
  }
  return setTypographyElement(attribute, field);
};
var buildRows = function buildRows(_ref) {
  var modifiedAttributes = _ref.modifiedAttributes,
    isEarlyAccess = _ref.isEarlyAccess;
  return modifiedAttributes.filter(function (attributeDetail) {
    return attributeDetail.attribute in DETAIL_TITLES;
  }).map(function (attributeDetail) {
    var attribute = attributeDetail.attribute,
      template = attributeDetail.template,
      instance = attributeDetail.instance;
    var attributeText = isEarlyAccess && attribute === 'requiredState' ? DETAIL_TITLES.requiredStateEarlyAccess : DETAIL_TITLES[attribute];
    var templateComponent = setElement(attribute, template);
    var instanceComponent = setElement(attribute, instance);
    return {
      attributeTitle: /*#__PURE__*/React.createElement(Typography, {
        variant: "button"
      }, attributeText),
      template: templateComponent,
      instance: instanceComponent
    };
  });
};
var Details = function Details(_ref2) {
  var modifiedAttributes = _ref2.modifiedAttributes,
    isEarlyAccess = _ref2.isEarlyAccess;
  return /*#__PURE__*/React.createElement(Table, {
    "aria-label": "Requirement Details"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCellStyled, {
    width: "16%"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "section"
  }, DETAIL_TITLES.attribute)), /*#__PURE__*/React.createElement(TableCellStyled, {
    width: "42%"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "section"
  }, DETAIL_TITLES.template)), /*#__PURE__*/React.createElement(TableCellStyled, {
    width: "42%"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "section"
  }, DETAIL_TITLES.instance)))), /*#__PURE__*/React.createElement(TableBody, null, buildRows({
    modifiedAttributes: modifiedAttributes,
    isEarlyAccess: isEarlyAccess
  }).map(function (row, rowIndex) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: "".concat(rowIndex, "-row")
    }, /*#__PURE__*/React.createElement(TableCellStyled, {
      component: "th",
      scope: "row"
    }, row.attributeTitle), /*#__PURE__*/React.createElement(TableCellStyled, null, row.template), /*#__PURE__*/React.createElement(TableCellStyled, null, row.instance));
  })));
};
export default /*#__PURE__*/React.memo(Details);